export default __webpack_public_path__ + "static/media/certificado_dos.35585d02.PNG";